import { createSelector } from '@reduxjs/toolkit';
import { getInitialMessageText } from './getInitialMessageText';
import { showQuickReplyOutsideChat } from '../../utils/showQuickRepliesOutsideChat';
import { getStagedThreadHistory } from '../../thread-create/selectors/stagedThreadSelectors';
// @ts-expect-error not typed
import { threadHistoryToMessageList } from 'conversations-message-history/thread-history/operators/threadHistoryToMessageList';
export const getInitialMessageForWelcomePage = createSelector([getInitialMessageText, showQuickReplyOutsideChat, getStagedThreadHistory], (baseInitialMessageText, displayBotQuickRepliesOutsideChat, stagedThreadHistory) => {
  if (!displayBotQuickRepliesOutsideChat) {
    return baseInitialMessageText;
  }
  const messageRecords = stagedThreadHistory ? threadHistoryToMessageList(stagedThreadHistory) : [];
  return messageRecords.reduce((acc, msg) => acc += ` ${msg.text}`, '');
});